module.exports = __webpack_public_path__ + "img/csr_032423_D.1efaa771.jpg";